/**
 * Created with IntelliJ IDEA.
 * User: abahlk
 * Date: 12.07.13
 * Time: 12:13
 * To change this template use File | Settings | File Templates.
 */

import { ExternalLoggingConstants } from "../ExternalLoggingConstants";
import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { BasicLogObjectFactory } from "./BasicLogObjectFactory";

export class VersionErrorLOFactory extends BasicLogObjectFactory {
    public static OLD_CLIENT_VERSION_ERROR: number = 10001;
    public static VERSION_TOO_HIGH_ERROR: number = 10002;

    private static VERSION_ERROR: number = 10;

    private static PARAM_SERVER_VERSION: string = "serverVersion";

    private _serverVersion: string;

    constructor(subErrorId: number, serverVersion: string) {
        super();

        this._subErrorId = subErrorId;
        this._serverVersion = serverVersion;
    }

    public create(): AbstractLogObject {
        // Build the commonData
        let lo: AbstractLogObject = super.create();

        // Update with customData
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_EVENT_ID, VersionErrorLOFactory.VERSION_ERROR.toString());
        lo.logData.set(VersionErrorLOFactory.PARAM_SERVER_VERSION, this._serverVersion);

        return lo;
    }
}
